import { useState, useContext, useEffect } from 'react';
import { Box, Card, CardActionArea, CardContent, Typography } from '@mui/material';
import { useOktaAuth } from '@okta/okta-react';

import { AuthContext, AuthContextType } from 'src/contexts/AuthContext';
import { Conversation, getAllConversations } from 'src/api';
import { useChatbotContext } from 'src/contexts/ChatbotContext';
import { format } from 'date-fns';
import _ from 'lodash';

export const ChatbotHistory = ({ setToChatModeChat }: { setToChatModeChat: () => void }) => {
  const { authState } = useOktaAuth();
  const { activeMemberId } = useContext(AuthContext) as AuthContextType;
  const [loading, setLoading] = useState<boolean>(false);
  const [conversationList, setConversationList] = useState<Conversation[]>([]);
  const { loadPreviousConversation } = useChatbotContext();

  const handleHistoryClick = (conversation: Conversation) => {
    loadPreviousConversation(conversation);
    setToChatModeChat();
  };

  useEffect(() => {
    setLoading(true);
    getAllConversations({
      memberid: authState?.accessToken?.accessToken ?? '',
      token: activeMemberId ?? '',
      onerror: (error) => {
        console.error('An error has occured', error);
      }
    })
      .then((res) => {
        if (res?.ok) {
          return res.json();
        } else {
          throw new Error('Problem getting Conversation history from server.');
        }
      })
      .then((json) => {
        const conversations = json as Conversation[];
        setConversationList(conversations);
        setLoading(false);
      });
  }, [activeMemberId, authState?.accessToken?.accessToken]);

  if (loading) {
    return 'Loading...';
  }
  return (
    <Box>
      {conversationList.map((conversation) => {
        const date = conversation?.date ? new Date(conversation?.date) : null;
        const dateString = date ? format(date, 'eee do MMM yyyy') : '';
        const firstMessage = _.first(conversation?.messages)?.content;
        return (
          <Card elevation={1}>
            <CardActionArea onClick={() => handleHistoryClick(conversation)}>
              <CardContent>
                <Typography variant="body1">{conversation.title}</Typography>
                {firstMessage && (
                  <Typography variant="body2" sx={{ pl: 2 }}>
                    {firstMessage}
                  </Typography>
                )}
                {dateString && (
                  <Typography variant="body2" sx={{ textAlign: 'end' }}>
                    {dateString}
                  </Typography>
                )}
              </CardContent>
            </CardActionArea>
          </Card>
        );
      })}
    </Box>
  );
};
